
import { Component, Vue } from 'vue-property-decorator';
import DevScrumRepository from "@/services/Dev-scrum";
import { ComponentStatus } from "@/services/Dev-scrum/interfaces";
import EditComponentForm from "@/services/Dev-scrum/forms/EditComponentForm";

@Component({
  inject: [
    'devScrumRepository',
  ],
})
export default class EditComponent extends Vue {
  private readonly devScrumRepository!: DevScrumRepository;

  private loading: boolean = true;

  private form: EditComponentForm = new EditComponentForm;

  private componentStatusOptions = Object.values(ComponentStatus);

  private async created(): Promise<void> {
    const component = await this.devScrumRepository.getComponentById(Number(this.$route.params.componentId));
    this.form.name = component.name;
    this.form.status = component.status;
    this.loading = false;
  }

  private async editComponent(): Promise<void> {
    try {
      await this.devScrumRepository.editComponent(Number(this.$route.params.componentId), {
        name: this.form.name,
        status: this.form.status,
      })

      this.$successDialog.show(`Successfully updated component '${this.form.name}'`);
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
    }
  }

}
